import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { CheckCircle, Loader } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = window.location.origin;

const PaymentSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (sessionId) {
      checkPaymentStatus();
    }
  }, [sessionId]);

  const checkPaymentStatus = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/payments/status/${sessionId}`);
      setPaymentStatus(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error checking payment:', error);
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{ 
        paddingTop: '80px',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div style={{ textAlign: 'center' }}>
          <Loader size={48} className="animate-spin" style={{ margin: '0 auto 1rem' }} />
          <p className="body-large">Vérification du paiement...</p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ paddingTop: '80px', minHeight: '100vh' }}>
      <div className="container" style={{ 
        maxWidth: '700px',
        padding: '5rem 1.2rem',
        textAlign: 'center'
      }}>
        <div className="card" style={{ 
          padding: '3rem 2rem',
          background: 'var(--gradient-hero-warm)'
        }}>
          <CheckCircle 
            size={80} 
            style={{ 
              color: 'green',
              margin: '0 auto 2rem'
            }} 
          />
          
          <h1 className="heading-1" style={{ marginBottom: '1rem' }}>
            Paiement réussi !
          </h1>
          
          <p className="body-large" style={{ marginBottom: '2rem' }}>
            Votre inscription a été confirmée. Vous allez recevoir un email de confirmation 
            à l'adresse indiquée lors du paiement.
          </p>

          {paymentStatus && (
            <div className="card" style={{ 
              padding: '1.5rem',
              marginBottom: '2rem',
              background: 'white',
              textAlign: 'left'
            }}>
              <h3 className="heading-3" style={{ marginBottom: '1rem' }}>
                Détails de votre commande
              </h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span className="body-small" style={{ color: 'var(--text-muted)' }}>Formation :</span>
                  <span className="body-small" style={{ fontWeight: 500 }}>
                    {paymentStatus.metadata?.program_name || 'Formation VAE'}
                  </span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span className="body-small" style={{ color: 'var(--text-muted)' }}>Montant :</span>
                  <span className="body-small" style={{ fontWeight: 500 }}>
                    {paymentStatus.amount?.toFixed(2)}€
                  </span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span className="body-small" style={{ color: 'var(--text-muted)' }}>Statut :</span>
                  <span className="body-small" style={{ fontWeight: 500, color: 'green' }}>
                    {paymentStatus.paymentStatus === 'paid' ? 'Payé' : 'En attente'}
                  </span>
                </div>
                {paymentStatus.metadata?.urgent_vae === 'true' && (
                  <div style={{ 
                    marginTop: '0.5rem',
                    padding: '0.75rem',
                    background: 'var(--accent-orange-200)',
                    borderRadius: '0.5rem'
                  }}>
                    <span className="body-small">⚡ Formule Urgence VAE activée</span>
                  </div>
                )}
              </div>
            </div>
          )}

          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <Link to="/dashboard" className="btn-primary" style={{ width: '100%' }}>
              Accéder à mon espace
            </Link>
            <Link to="/" className="btn-secondary" style={{ width: '100%' }}>
              Retour à l'accueil
            </Link>
          </div>

          <p className="body-small" style={{ marginTop: '2rem', color: 'var(--text-muted)' }}>
            Un email de confirmation a été envoyé. Si vous ne le recevez pas, 
            contactez-nous à apdr.vae@gmail.com
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccessPage;
